export const composeEventFns = (fns) => (e) => fns.map((fn) => fn(e));
export const parseValue = (cb) => (e) => cb(e.target.value);
export const setValidity = (cb) => (e) => { var _a; return e.target.setCustomValidity((_a = cb(e.target.value, e.target.validity)) !== null && _a !== void 0 ? _a : ''); };
export const reportValidity = (e) => e.target.value && e.target.reportValidity();
